module.exports = __webpack_public_path__ + "static/media/footer_ico_consulting_store.226449cd.svg";